import { useQuery } from '@tanstack/react-query';

import { createChannelProgramsQueryOptions } from './queryOptions';

type UseChannelProgramsProps = {
  channelId: number;
  day: string;
  enabled?: boolean;
};

export function useChannelPrograms({ channelId, day, enabled = true }: UseChannelProgramsProps) {
  const { data, error, isLoading } = useQuery({
    enabled,
    ...createChannelProgramsQueryOptions(channelId, day),
  });

  return {
    error,
    programs: data,
    isLoading,
  };
}
